import { useScrollReveal } from '../../../hooks/useScrollReveal';

const services = [
  {
    num: '01',
    icon: 'ri-headphone-line',
    title: 'Télévendeurs dédiés',
    color: 'bg-white text-[#0A0A0A]',
    accent: '#6ECFA0',
    items: [
      'Qualification de leads entrants & sortants',
      'Prise de rendez-vous B2B & B2C',
      'Relances commerciales et closing',
      'Reporting quotidien transparent',
    ],
  },
  {
    num: '02',
    icon: 'ri-briefcase-4-line',
    title: 'Business Developers',
    color: 'bg-[#6ECFA0] text-white',
    accent: '#0A0A0A',
    items: [
      'Développement de nouveaux marchés',
      'Prospection stratégique ciblée',
      'Négociation et signature de contrats',
      'Cartographie des comptes clés',
    ],
  },
  {
    num: '03',
    icon: 'ri-bar-chart-grouped-line',
    title: 'Pilotage inclus',
    color: 'bg-[#00C97B] text-[#0A0A0A]',
    accent: '#0A0A0A',
    items: [
      'Manager commercial dédié',
      'KPIs et dashboards en temps réel',
      'Réunions de suivi hebdomadaires',
      'Ajustements stratégiques continus',
    ],
  },
];

export default function Solution() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <section id="solution" className="bg-[#0A0A0A] py-24 lg:py-32 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-[#6ECFA0]/5 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-96 h-96 rounded-full bg-[#00C97B]/5 blur-3xl pointer-events-none" />

      <div ref={ref} className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div
          className={`mb-16 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="inline-block text-[#6ECFA0] text-sm font-bold uppercase tracking-widest mb-4">
            Notre solution
          </span>
          <h2 className="text-4xl lg:text-5xl font-black text-white leading-tight mb-4">
            Une force commerciale clé en main
          </h2>
          <p className="text-[#00C97B] text-lg font-semibold">
            3 piliers pour accélérer vos ventes dès maintenant
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((s, i) => (
            <div
              key={s.title}
              className={`relative rounded-3xl p-10 overflow-hidden hover:-translate-y-2 transition-all duration-500 ${s.color} ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              {/* Big number */}
              <span
                className="absolute -top-4 -right-2 text-9xl font-black opacity-5 select-none leading-none"
                style={{ color: s.accent }}
              >
                {s.num}
              </span>

              {/* Icon */}
              <div
                className="w-14 h-14 flex items-center justify-center rounded-2xl mb-6"
                style={{ background: s.accent }}
              >
                <i className={`${s.icon} text-2xl`} style={{ color: i === 1 ? '#6ECFA0' : '#fff' }} />
              </div>

              <h3 className="text-2xl font-black mb-6">{s.title}</h3>

              <ul className="space-y-3">
                {s.items.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm leading-relaxed">
                    <i
                      className="ri-checkbox-circle-line text-base mt-0.5 shrink-0"
                      style={{ color: s.accent }}
                    />
                    <span className="opacity-80">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
